import { Chip, ChipProps } from "@mui/material";
import React from "react";
import { getContentTypeConfig } from "../../constants/contentTypes";

/**
 * Returns a styled chip component for a given content type
 * @param type Content type (blog_post, linkedin_post, etc.)
 * @param size Chip size (small or medium)
 * @returns Styled chip component with appropriate icon and color
 */
export const ContentTypeChip = ({
  type,
  size = "medium",
  ...chipProps
}: {
  type: string;
  size?: "small" | "medium";
} & Omit<ChipProps, "icon" | "label" | "color" | "size">) => {
  const config = getContentTypeConfig(type);

  if (!config) {
    return <Chip label={type.replace("_", " ")} size={size} {...chipProps} />;
  }

  const isGradient = config.color.includes("gradient");
  const isBlue = config.name === "blog_post";

  return (
    <Chip
      // @ts-ignore
      icon={config.icon}
      label={config.title}
      color={isBlue ? "primary" : undefined}
      size={size}
      sx={{
        fontWeight: "medium",
        ...(isGradient
          ? { background: config.color, color: "white" }
          : !isBlue
          ? { bgcolor: config.color, color: "white" }
          : {}),
        ...chipProps.sx,
      }}
      {...chipProps}
    />
  );
};

export default ContentTypeChip;
